import { render } from "./PartnerVendorRanking.vue?vue&type=template&id=d871495c&scoped=true"
import script from "./PartnerVendorRanking.vue?vue&type=script&lang=js"
export * from "./PartnerVendorRanking.vue?vue&type=script&lang=js"

import "./PartnerVendorRanking.vue?vue&type=style&index=0&id=d871495c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d871495c"]])

export default __exports__